import { randomInt } from '@CS/utils/Number';

// Fisher–Yates Shuffle Algorithm:
export function fisherYates<T>(a: T[], c = a.length, r = 0): void {
  while (c) {
    r = (Math.random() * c--) | 0;
    [a[c], a[r]] = [a[r], a[c]];
  }
}

// Durstenfeld Shuffle Algorithm:
export function durstenfeld<T>(a: T[]): void {
  for (let c = a.length; c--; ) {
    const r = Math.floor(Math.random() * (c + 1));
    [a[c], a[r]] = [a[r], a[c]];
  }
}

// Simple Shuffle Algorithm:
export function shuffle<T>(a: T[]): T[] {
  return a.sort(() => Math.random() - 0.5);
}

// Get random element from array
export function random<T>(a: T[]): T {
  return a[randomInt(0, a.length - 1)];
}
